var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v("Extra knoppen")]),
      _vm.buttons.length == 0
        ? _c(
            "w-card-content",
            [
              _c(
                "w-row",
                { attrs: { center: "" } },
                [
                  _c("w-col", { attrs: { center: "", xs: "12" } }, [
                    _vm._v(" Er zijn nog geen knoppen aangemaakt "),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-list",
        [
          _vm._l(_vm.buttons, function (button) {
            return _c(
              "w-list-item",
              { key: button.ID },
              [
                _c(
                  "w-list-item-icon",
                  [
                    button.Icon
                      ? _c("w-fa", { attrs: { icon: button.Icon } })
                      : _vm._e(),
                  ],
                  1
                ),
                _c("w-list-item-text", [
                  _vm._v(" " + _vm._s(button.Label) + " "),
                ]),
                _c(
                  "w-list-item-action",
                  [
                    _c(
                      "w-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.edit(button)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "pen" } })],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "w-list-item-action",
                  [
                    _c(
                      "w-button",
                      {
                        staticClass: "danger",
                        on: {
                          click: function ($event) {
                            return _vm.deleteButton(button)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "trash" } })],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _c(
            "w-list-item",
            {
              on: {
                click: function ($event) {
                  return _vm.createNew()
                },
              },
            },
            [
              _c(
                "w-list-item-icon",
                [_c("w-fa", { attrs: { icon: "plus" } })],
                1
              ),
              _c("w-list-item-text", [_vm._v("Nieuwe knop toevoegen")]),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }